import { Col, Row } from "react-bootstrap";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";
import { EnumHelper } from "../../../../helpers/EnumHelper";

const FixedAssetDetailMain = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("Group")} fieldName={"group"} items={EnumHelper.FixedAssetDetailTestTypeEnum()} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("Code")} fieldName={"code"} required />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Description")} fieldName={"description"} required />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("InventoryNumber")} fieldName={"inventoryNumber"} />
        </Col>
      </Row>
    </>
  );
};

export default FixedAssetDetailMain;
